import { genres, regions, years } from "@/mocks/tv/filters";

export type FilterGroup = "genres" | "regions" | "years";

interface FilterPanelProps {
  selectedGenres: string[];
  selectedRegions: string[];
  selectedYears: string[];
  onToggle: (group: FilterGroup, value: string) => void;
  onReset: () => void;
  resultCount: number;
  hasActiveFilter: boolean;
}

interface GroupProps {
  title: string;
  options: string[];
  selected: string[];
  group: FilterGroup;
  onToggle: (group: FilterGroup, value: string) => void;
}

function FilterGroup({ title, options, selected, group, onToggle }: GroupProps) {
  return (
    <div className="pb-5 mb-5 border-b border-background-200 last:border-b-0 last:pb-0 last:mb-0">
      <h4 className="text-sm font-semibold text-foreground-900 mb-3">{title}</h4>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const active = selected.includes(option);
          return (
            <button
              key={option}
              type="button"
              onClick={() => onToggle(group, option)}
              className={`px-3 py-1.5 text-xs rounded-full border transition-colors cursor-pointer whitespace-nowrap ${
                active
                  ? "bg-primary-500 border-primary-500 text-background-50"
                  : "bg-background-50 border-background-200 text-foreground-600 hover:border-primary-400 hover:text-primary-600"
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterPanel({
  selectedGenres,
  selectedRegions,
  selectedYears,
  onToggle,
  onReset,
  resultCount,
  hasActiveFilter,
}: FilterPanelProps) {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading text-lg font-bold text-foreground-900">筛选</h3>
        <button
          type="button"
          onClick={onReset}
          disabled={!hasActiveFilter}
          className="text-xs text-foreground-500 hover:text-accent-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer transition-colors whitespace-nowrap"
        >
          重置筛选
        </button>
      </div>

      <div className="mb-4 px-3 py-2 rounded-md bg-secondary-100 text-secondary-900 text-xs">
        共找到 <strong className="font-semibold">{resultCount}</strong> 部符合条件的作品
      </div>

      <FilterGroup title="类型" options={genres} selected={selectedGenres} group="genres" onToggle={onToggle} />
      <FilterGroup title="地区" options={regions} selected={selectedRegions} group="regions" onToggle={onToggle} />
      <FilterGroup title="年份" options={years} selected={selectedYears} group="years" onToggle={onToggle} />
    </div>
  );
}